import React from "react";
import Image from "next/image";
import cn from "classnames";
import styles from "./styles.module.scss";

const Stats = ({ data, alt = false, className }) => {
  const shouldDisplayInTwo = data?.length % 4 === 0;
  return (
    <div className={cn(styles.wrapper, "container")}>
      <div
        className={cn(
          styles.container,
          alt && styles.container_alt,
          shouldDisplayInTwo && styles.container_gridTwo,
          className
        )}
      >
        {data?.map((item) => {
          return (
            <div
              className={alt ? cn(styles.item, styles.item_alt) : styles.item}
            >
              <Image width={92} height={92} src={item.src} alt={item.src} />
              <div
                className={alt ? cn(styles.text, styles.text_alt) : styles.text}
              >
                {item.text}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default Stats;
